var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_16_-_light",
    "data-name": "16 - light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 20.058,
    viewBox: "0 0 21.6 20.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7419",
    "data-name": "Path 7419",
    d: "M12.8,18.429a5.886,5.886,0,0,1-1.219-.123A6.172,6.172,0,0,1,8.7,7.629.771.771,0,0,0,8.943,7.1V5.314A2.314,2.314,0,0,1,11.257,3h3.086a2.314,2.314,0,0,1,2.314,2.314V7.1a.771.771,0,0,0,.231.548A6.172,6.172,0,0,1,12.8,18.429ZM11.257,4.543a.771.771,0,0,0-.771.771V7.1a2.314,2.314,0,0,1-.771,1.7,4.646,4.646,0,1,0,6.171-.008,2.268,2.268,0,0,1-.771-1.7V5.314a.771.771,0,0,0-.771-.771ZM12.8,23.058a.771.771,0,0,1-.771-.771V20.743a.771.771,0,1,1,1.543,0v1.543A.771.771,0,0,1,12.8,23.058ZM5.711,20.119a.768.768,0,0,1-.548-1.311l1.088-1.1a.775.775,0,0,1,1.1,1.1l-1.1,1.088A.771.771,0,0,1,5.711,20.119Zm-1.4-7.09H2.771a.771.771,0,0,1,0-1.543H4.314a.771.771,0,0,1,0,1.543Zm15.575,7.09a.771.771,0,0,1-.54-.224l-1.1-1.088a.775.775,0,1,1,1.1-1.1l1.088,1.1a.768.768,0,0,1-.548,1.311Zm2.939-7.09H21.286a.771.771,0,0,1,0-1.543h1.543a.771.771,0,0,1,0,1.543Z",
    transform: "translate(-2 -3)",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIcon);
export default __webpack_public_path__ + "static/media/light-icon.c8435352a568b6c6ac2d9d7fb15f1d5e.svg";
export { ForwardRef as ReactComponent };